module.exports = __webpack_public_path__ + "img/admin_set.e3870a2c.png";